import { render } from "./identity_verification_results.html?vue&type=template&id=cdf9b574&external"
import script from "./identity_verification_results.js?vue&type=script&lang=js&external"
export * from "./identity_verification_results.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__